<ng-container *ngIf="params.value">
  <ng-container *ngIf="columnConfig.isProjectName">
    <a
      [title]="
        (accessConfig.checkAllProjectDashboardAccess && activatedRoute === 'dashboard') ||
        (accessConfig.checkAllProductDashboardAccess && activatedRoute === 'dashboard') ||
        accessConfig.checkProjectAccess
          ? clickTooltipDef
          : ''
      "
      (click)="routeTo()"
      [id]="accessConfig.showProjectEdit ? 'resendMail' : 'one'"
      [ngClass]="accessConfig.showProjectEdit ? 'firstNameStatus' : 'projectName'"
    >
      {{ params.data.projectName }}
    </a>
  </ng-container>

  <ng-container *ngIf="columnConfig.isProductName">
    <a
      [title]="accessConfig.checkProductAccess ? clickTooltipDef : ''"
      (click)="routeToProduct()"
      [id]="accessConfig.showProjectEdit ? 'resendMail' : 'one'"
      [ngClass]="accessConfig.showProductEdit ? 'firstNameStatus' : 'projectName'"
    >
      {{ params.data.productName }}
    </a>
  </ng-container>
</ng-container>
